import React, { useEffect, useState } from "react";
import reviewMan from "../../../Images/someMan2.gif";
import thumbsDownImage from "../../../Images/thumbsDown.png";
import thumpsUpImage from "../../../Images/thumbsUp.png";

function ReviewLimit() {
  const [satisfiedState, setSatisfiedState] = useState("");
  const [valueState, setValueState] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const mixpanelFunction = (props) => {
    
    // 
    setTimeout(() => {
      const redirect = new URLSearchParams(window.location.search).get("redirect");
      const canApplyForLoan = new URLSearchParams(window.location.search).get("canapplyforloan");
      
      if (redirect !== "profile") {
          if (canApplyForLoan === "true") {
              window.location.href = "/apply_loan";
          } else {
            window.location.href = "/apply_loan";
              // window.location.href = "/super-loan-dashboard";
          }
      } else {
        window.location.href = "/apply_loan";
          // window.location.href = "/completeprofilenew";
      }

    }, 1000);

   
  };


  const yesHandler = () => {
    const creditLimit = new URLSearchParams(window.location.search).get("limit");
    const userType = localStorage.getItem("user_type");
  
    setSatisfiedState("YES");
  
   
  };

  
  return (
    <>
     {isLargeScreen &&
    <div className=" pb-30 shadowlinepure  ">
        <div style={{ width: 320 }} className="maxwidth pl-20">
          <div className="pb-20 ">
            <h1
              className="boldheading"
              style={{
                paddingLeft: "42px",
                color: "#152745",
                fontWeight: "1000",
                fontSize: "26px",
                marginTop: 30,
              }}
            >
              Review your limit
            </h1>
          </div>
        </div>
      </div>}
    <div className="toolbarRespo">
    {!isLargeScreen &&
    <div className=" pb-30 shadowlinepure maxWidth450 ">
        <div style={{ width: 320 }} className="maxwidth pl-20">
          <div className="pb-20 ">
            <h1
              className="boldheading"
              style={{
                paddingLeft: "42px",
                color: "#152745",
                fontWeight: "1000",
                fontSize: "26px",
                marginTop: 30,
              }}
            >
              Review your limit
            </h1>
          </div>
        </div>
      </div>}
      </div>
    <div className="container toolbarRespo">
      

      <div className="socialContainer">
        <div className="socialMedia">
          <img src={reviewMan} className="socialMediaImage" />
        </div>
        <div className="textSocial">
          <p className="questionSocial">
            Are you satisfied with your credit limit?
          </p>
          <p className="socialOption">
            <p
              onClick={() => {
                yesHandler();
              }}
              className={
                satisfiedState === "YES"
                  ? "socialBox color-orange"
                  : "socialBox"
              }
            >
              Yes
              <img height={17} width={17} src={thumpsUpImage} />
            </p>
            <p
              onClick={() => {
                setSatisfiedState("NO");
              }}
              className={
                satisfiedState === "NO" ? "socialBox color-orange" : "socialBox"
              }
            >
              No
              <img height={17} width={17} src={thumbsDownImage} />
            </p>
          </p>
          {satisfiedState === "NO" && (
            <>
              <p className="questionSocial">
                What loan amount are you seeking?
              </p>
              <p className="socialOption">
                <p
                  onClick={() => {
                    setValueState("1");
                    mixpanelFunction();
                  }}
                  className={
                    valueState === "1" ? "priceBox color-orange" : "priceBox"
                  }
                >
                  ₹10,000 - ₹50,000
                </p>
                <p
                  onClick={() => {
                    setValueState("2");
                    mixpanelFunction();
                  }}
                  className={
                    valueState === "2" ? "priceBox color-orange" : "priceBox"
                  }
                >
                  ₹50,000 - ₹1,00,000
                </p>
              </p>
              <div className="socialOption">
                <p
                  onClick={() => {
                    setValueState("3");
                    mixpanelFunction();
                  }}
                  className={
                    valueState === "3" ? "priceBox color-orange" : "priceBox"
                  }
                >
                  ₹1,00,000 - ₹1,50,000
                </p>
                <p
                  onClick={() => {
                    setValueState("4");
                  }}
                  className={
                    valueState === "4" ? "priceBox color-orange" : "priceBox"
                  }
                >
                  ₹1,50,000 - ₹2,00,000
                </p>
              </div>
            </>
          )}

          <div
            onClick={() => {
              const redirect = new URLSearchParams(window.location.search).get("redirect");
              const canApplyForLoan = new URLSearchParams(window.location.search).get("canapplyforloan");
              
              if (redirect !== "profile") {
                  if (canApplyForLoan === "true") {
                      window.location.href = "/apply_loan";
                  } else {
                    window.location.href = "/apply_loan";
                      // window.location.href = "/super-loan-dashboard";
                  }
              } else {
                window.location.href = "/apply_loan";
                  // window.location.href = "/completeprofilenew";
              }
              
              //window.location.href = "/apply_loan";
            }}
            className="skipOption"
          >
            Skip
          </div>
        </div>
      </div>
    </div>
     </>
  );
}

export default ReviewLimit;
